export default function Footer() {
  const quickLinks = [
    { label: '关于我们', href: '#about' },
    { label: '核心业务', href: '#business' },
    { label: '解决方案', href: '#solutions' },
    { label: '客户案例', href: '#cases' },
  ];

  const support = [
    { label: '技术文档', href: '#' },
    { label: '常见问题', href: '#' },
    { label: '下载中心', href: '#' },
    { label: '在线客服', href: '#' },
  ];

  const socialMedia = [
    { icon: 'ri-wechat-fill', label: '微信', href: '#' },
    { icon: 'ri-weibo-fill', label: '微博', href: '#' },
    { icon: 'ri-linkedin-fill', label: 'LinkedIn', href: '#' },
  ];

  return (
    <footer className="bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-white">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-12 md:py-14 lg:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10 lg:gap-12">
          {/* Company Info */}
          <div className="sm:col-span-2 lg:col-span-1">
            <img
              src="https://static.readdy.ai/image/335e3e62ea46a4ee8fffcd870552cca1/45145859d95338398b93e9f0fa2b0f33.png"
              alt="龙创未来"
              className="h-10 md:h-12 w-auto mb-4 md:mb-6"
            />
            <p className="text-sm text-gray-400 leading-relaxed mb-4 md:mb-6">
              福建龙创未来股份有限公司是一家以人工智能与智能科技为核心的高新技术企业，致力于以技术驱动产业升级、以智能赋能数字化转型。
            </p>
            <div className="flex gap-3">
              {socialMedia.map((social) => (
                <a
                  key={social.label}
                  href={social.href}
                  className="w-9 h-9 md:w-10 md:h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-teal-600 transition-colors cursor-pointer"
                  aria-label={social.label}
                >
                  <i className={`${social.icon} text-base md:text-lg`}></i>
                </a>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-base md:text-lg font-semibold mb-4 md:mb-6 relative inline-block">
              快速链接
              <span className="absolute bottom-0 left-0 w-12 h-0.5 bg-teal-600"></span>
            </h3>
            <ul className="space-y-2.5 md:space-y-3">
              {quickLinks.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Support */}
          <div>
            <h3 className="text-base md:text-lg font-semibold mb-4 md:mb-6 relative inline-block">
              服务支持
              <span className="absolute bottom-0 left-0 w-12 h-0.5 bg-teal-600"></span>
            </h3>
            <ul className="space-y-2.5 md:space-y-3">
              {support.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div className="sm:col-span-2 lg:col-span-1">
            <h3 className="text-base md:text-lg font-semibold mb-4 md:mb-6 relative inline-block">
              联系我们
              <span className="absolute bottom-0 left-0 w-12 h-0.5 bg-teal-600"></span>
            </h3>
            <ul className="space-y-3 md:space-y-4">
              <li className="flex items-start gap-3">
                <i className="ri-map-pin-line text-teal-600 text-base md:text-lg mt-0.5 flex-shrink-0"></i>
                <span className="text-sm text-gray-400">
                  福建省龙岩市新罗区东肖经济开发区曲潭路15号科技创业园4号楼10楼
                </span>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-phone-line text-teal-600 text-base md:text-lg mt-0.5 flex-shrink-0"></i>
                <a href="tel:18159811888" className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer">
                  18159811888
                </a>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-mail-line text-teal-600 text-base md:text-lg mt-0.5 flex-shrink-0"></i>
                <a href="mailto:wuzb@fjdell.com" className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer break-all">
                  wuzb@fjdell.com
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Footer */}
      <div className="border-t border-gray-800">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-5 md:py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-3 md:gap-4 text-sm text-gray-400">
            <div className="text-center md:text-left">
              © 2025 福建龙创未来股份有限公司 版权所有
            </div>
            <div className="flex flex-wrap items-center justify-center gap-2 md:gap-4 text-xs md:text-sm">
              <a href="#" className="hover:text-white transition-colors cursor-pointer">
                隐私政策
              </a>
              <span className="hidden md:inline">|</span>
              <a href="#" className="hover:text-white transition-colors cursor-pointer">
                使用条款
              </a>
              <span className="hidden md:inline">|</span>
              <a href="#" className="hover:text-white transition-colors cursor-pointer">
                网站地图
              </a>
              <span className="hidden md:inline">|</span>
              <a href="https://beian.miit.gov.cn/" target="_blank" rel="nofollow noopener noreferrer" className="hover:text-white transition-colors cursor-pointer">
                闽ICP备2025090460号
              </a>
              <span className="hidden md:inline">|</span>
              <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors cursor-pointer">
                Powered by Readdy
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}